import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { cashdeskTransactionSchema } from '../types';

export type DepositPlayerMutationParams = {
	id: number;
	amount: number;
};

export const createDepositPlayerMutation = () =>
	createAuthMutation({
		params: declareParams<DepositPlayerMutationParams>(),
		request: {
			method: 'POST',
			url: (params) => `/device/replenish/${params.id}`,
			body: (data) => ({
				amount: data.amount,
			}),
		},
		response: {
			contract: zodContract(cashdeskTransactionSchema),
		},
	});
